module.exports = __webpack_public_path__ + "img/032-good.09886908.svg";